var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"small":"","color":_vm.theChipColor},domProps:{"textContent":_vm._s(_vm.value)},on:{"click":_vm.toRouter}})}
var staticRenderFns = []

export { render, staticRenderFns }